// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import API from './utils/APIUtils'
import fetch from './utils/fetch'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import 'element-ui/lib/theme-chalk/display.css';
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import zh from './i18n/zh' // 简体中文语言包
import en from './i18n/en' // 英文语言包
import tw from './i18n/tw' // 繁体中文语言包
const i18n = new VueI18n({
  locale: window.localStorage.getItem('language') === null ? 'zh' : window.localStorage.getItem('language'), // 语言标识，设置默认语言
  messages: {
    'zh': zh, // 简体中文
    'en': en, // 英文
    'tw': tw // 繁体中文
  }
})
Vue.use(ElementUI);
const extend = Vue.prototype
extend.$axios = axios;
extend.$post = fetch.post
extend.$get = fetch.get
extend.WindowApi = window.windowUrl
extend.API = API;
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js